<template>
  <el-menu
    :default-active="activeMenu"
    :collapse="collapse"
    background-color="#304156"
    text-color="#bfcbd9"
    active-text-color="#409EFF"
    :unique-opened="true"
    router
  >
    <template v-for="route in validRoutes">
      <el-submenu v-if="route.children && route.children.length > 1" :key="route.path" :index="route.path">
        <template slot="title">
          <i :class="getIcon(route)" />
          <span>{{ getTitle(route) }}</span>
        </template>
        <el-menu-item v-for="child in route.children" :key="route.path + '/' + child.path" :index="route.path + '/' + child.path">
          {{ child.meta && child.meta.title }}
        </el-menu-item>
      </el-submenu>
      <el-menu-item v-else-if="route.children && route.children.length === 1" :key="route.path" :index="route.path + (route.children[0].path ? '/' + route.children[0].path : '')">
        <i :class="getIcon(route)" />
        <span slot="title">{{ getTitle(route) }}</span>
      </el-menu-item>
      <el-menu-item v-else :key="route.path" :index="route.path">
        <i :class="getIcon(route)" />
        <span slot="title">{{ getTitle(route) }}</span>
      </el-menu-item>
    </template>
  </el-menu>
</template>

<script>
export default {
  name: 'Sidebar',
  props: {
    routes: {
      type: Array,
      default: () => []
    },
    collapse: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    activeMenu() {
      return this.$route.path
    },
    validRoutes() {
      return this.routes.filter(route => route && route.path && (route.meta || (route.children && route.children[0] && route.children[0].meta)))
    }
  },
  methods: {
    getIcon(route) {
      if (route.meta && route.meta.icon) return route.meta.icon
      if (route.children && route.children[0] && route.children[0].meta && route.children[0].meta.icon) return route.children[0].meta.icon
      return 'el-icon-menu'
    },
    getTitle(route) {
      if (route.meta && route.meta.title) return route.meta.title
      if (route.children && route.children[0] && route.children[0].meta && route.children[0].meta.title) return route.children[0].meta.title
      return ''
    }
  }
}
</script>

<style scoped>
.el-menu {
  border-right: none;
}
</style>
